import Paper, { PaperProps, paperTheme } from './Paper';

export default Paper;

export { paperTheme };

export type { PaperProps };
